/** Nested bullet list formatting — mirrors backend list_format.py */

export const MAX_LIST_LEVEL = 8;
export const LIST_INDENT_PX = 28;

const BULLET_MARKERS = ['•', '◦', '▪', '‣', '–'];

const BULLET_PREFIX_RE = /^[\s]*(?:[•◦▪‣\-–*]|\d+[.)])\s*/u;

export function clampListLevel(level) {
  const n = Number(level);
  if (!Number.isFinite(n)) return 0;
  return Math.max(0, Math.min(MAX_LIST_LEVEL, Math.trunc(n)));
}

export function listIndentPx(level) {
  return LIST_INDENT_PX * clampListLevel(level);
}

export function bulletMarker(level) {
  const lv = clampListLevel(level);
  return BULLET_MARKERS[lv % BULLET_MARKERS.length];
}

export function stripBulletPrefix(text) {
  let s = String(text || '').trim();
  while (true) {
    const nxt = s.replace(BULLET_PREFIX_RE, '').trim();
    if (nxt === s) break;
    s = nxt;
  }
  return s;
}

export function explicitListLevel(block) {
  const keys = ['list_level', 'depth', 'nest_level', 'indent_level', 'nesting'];
  for (const key of keys) {
    if (block?.[key] != null) return clampListLevel(block[key]);
  }
  return null;
}

export function elementListLevel(el) {
  if (el?.list_level != null) return clampListLevel(el.list_level);
  const ctx = el?.slide_context;
  if (ctx?.list_level != null) return clampListLevel(ctx.list_level);
  return 0;
}

export function formatListDisplay(content, level = 0, blockType = 'bullet') {
  const lv = clampListLevel(level);
  const text = stripBulletPrefix(content);
  if (!text) return '';
  if (blockType === 'scene_title') return text;
  return `${bulletMarker(lv)} ${text}`;
}

export function applyListLayout(layout, level) {
  const lv = clampListLevel(level);
  const base = { ...(layout || {}) };
  base.x = Number(base.x ?? 64) + listIndentPx(lv);
  base.list_level = lv;
  return base;
}
